import React, { useState, useEffect } from "react";
import { FaArrowRight } from "react-icons/fa";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
import ReactHtmlParser from "react-html-parser";
import { Link, useNavigate } from "react-router-dom";
import penicon from "../../assets/images/pen-icon.png";
import bookicon from "../../assets/images/book-icon.png";
import Footer from "../footer/Footer";
import Gallery from "./Gallery";
import Header from "../header/Header";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaNewspaper } from "react-icons/fa";
import { FaLayerGroup } from "react-icons/fa";
import Banners from "./Banners";
import Campus from "./Campus";
import Carousel from "react-bootstrap/Carousel";
import {
  GetHomePageData,
  GetNewsEvents,
  GetExploreAdd,
} from "../../api/Global";
import about1 from "../../assets/images/4.webp";
import { Bars } from "react-loader-spinner";
import imagebaseurl from "../../config/imageurl";
import backgroundImageUrl from "../../assets/images/8.jpg";
// import Modal from 'react-bootstrap/Modal';
import { CreateStudentEnquirey } from "../../api/Global";

import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet-async";
import Marquee from "./Marquee";
import InstitutionHighlights from "./InstitutionHighlights";

const Home = () => {
  const [image, setImage] = useState([]);
  const [slides, setSlides] = useState([]);
  const [data, setData] = useState([]);
  const [homeBanners, setHomeBanner] = useState([]);
  const [isLoading, setIsLoading] = useState([]);
  const [placementList, setPlacementList] = useState([]);
  const [exploreBanners, setExploreBanners] = useState([]);
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [course, setCourse] = useState("");
  const [mathAnswer, setMathAnswer] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showModal, setShowModal] = useState(false);

  const [nameError, setNameError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [cityError, setCityError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [courseError, setCourseError] = useState("");
  const [sumAnswerError, setsumAnswerError] = useState("");

  const HandleSubmit = async (e) => {
    e.preventDefault();

    setNameError("");
    setMobileError("");
    setCityError("");
    setEmailError("");
    setCourseError("");
    setsumAnswerError("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const indianMobileRegex = /^[6-9]\d{9}$/;

    if (!name.trim()) return setNameError("Name is required!");

    if (!email.trim()) return setEmailError("Email is required!");
    if (!emailRegex.test(email.trim()))
      return setEmailError(
        "Please provide a correct email, invalid email format!"
      );

    if (!mobile.trim()) return setMobileError("Mobile number is required!");
    if (!indianMobileRegex.test(mobile.trim()))
      return setMobileError("Invalid mobile number format");
    if (!city.trim()) return setCityError("City is required!");

    if (!course.trim()) return setCourseError("Course is required!");

    if (!mathAnswer.trim()) return setsumAnswerError("Please add the sum!");
    if (mathAnswer.toString() !== "14")
      return setsumAnswerError("Please add and put the correct value");
    const data = {
      name,
      email,
      mobile,
      email,
      city,
      course,
      mathAnswer,
    };
    try {
      const response = await CreateStudentEnquirey(data);

      if (response?.data?.status == true) {
        navigate("/Thank_You");
        setName("");
        setEmail("");
        setMobile("");
        setCity("");
        setCourse("");
        setMathAnswer("");
        setShow(false);
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  const handleClick = () => {
    navigate("/Fees_Structure_Pdf");
  };
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const HandleGetPlacementList = async () => {
    setIsLoading(true);
    try {
      const response = await GetNewsEvents();

      if (Array.isArray(response?.data?.data)) {
        // Sorting the events in descending order (latest first)
        const sortedData = response.data.data.sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );

        setPlacementList(sortedData);
      } else {
        setPlacementList([]);
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching placement list:", error);
      setIsLoading(false);
    }
  };

  const HandleGetGetExploreAdd = async () => {
    // setIsLoading(true)
    try {
      const response = await GetExploreAdd();
      setExploreBanners(response?.data?.data);

    } catch (error) {
      console.log("setExploreBanners", error);
    }
  };

  useEffect(() => {
    localStorage.removeItem("ActiveTabs");
  });

  const FetchHomePageData = async () => {
    setIsLoading(true);
    try {
      const response = await GetHomePageData();
      setData(response.data.data.factsInfo);
      setSlides(response.data.data.placementsBlogs);
      setHomeBanner(response.data.data.homeBanners);
      if (Array.isArray(response.data.data.aboutUs)) {
        setImage(response.data.data.aboutUs);
        
      }
      console.error("api error", response.data.data.placementsBlogs);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(true);
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    FetchHomePageData();
    HandleGetPlacementList();
    HandleGetGetExploreAdd();
  }, []);

  const [showTopIcon, setShowTopIcon] = useState(false);

  // Scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Scroll to bottom
  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  // Handle scroll to toggle visibility of buttons
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (scrollTop === 0) {
      setShowTopIcon(false); // At the top, show scroll-down button
    } else if (scrollTop + clientHeight >= scrollHeight) {
      setShowTopIcon(true); // At the bottom, show scroll-up button
    } else {
      setShowTopIcon(scrollTop > 0); // Show scroll-up button when scrolling
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const closeModal = () => setShowModal(false);
  const openModal = () => setShowModal(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      openModal();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleShowAdmissionEnquiryForm = (index) => {
    if (index.toString() === "0") {
      openModal();
    }
  };
  const bannerImageAltText = [
    "best colleges for engineering",
    "best engineering colleges in madhya pradesh",
  ];
  return (
    <div>
      {isLoading ? (
        <>
          <div className="chat-window text-center">
            <div
              style={{
                position: "absolute",
                top: 0,
                bottom: 0,
                margin: "auto",
                zIndex: "999",
              }}
              className="spinner-border"
              role="status"
            >
              <span className="sr-only"></span>
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            className="page-template-default page page-id-2585 desktop desktop-menu mobile-menu-push-to-left header-sticky-both wide 
                        page-has-no-sidebar title-bar-none woocommerce elementor-default elementor-kit-22 elementor-page elementor-page-2585 e--ua-blink 
                        e--ua-chrome e--ua-webkit loaded"
            data-elementor-device-mode="desktop"
          >
            <Header />

            <Marquee onClick={openModal} />

            <Helmet>
              <title>
                CDGI - Top Engineering College in Madhya Pradesh | UG & PG
                Courses
              </title>
              <meta
                name="description"
                content="CDGI is the top engineering college in Madhya Pradesh, NAAC A+ accredited, AICTE-approved, affiliated to RGPV Bhopal & DAVV Indore for quality education."
              />
              <meta name="robots" content="index, follow" />
              <meta
                property="og:title"
                content="CDGI - Top Engineering College in Madhya Pradesh"
              />
              <meta
                property="og:description"
                content="CDGI is NAAC A+ accredited, AICTE-approved, and affiliated to RGPV Bhopal & DAVV Indore. Discover top UG & PG engineering courses in Madhya Pradesh."
              />
              <meta property="og:type" content="website" />
              <meta property="og:url" content="https://www.cdgi.edu.in/" />
              <link rel="canonical" href="https://www.cdgi.edu.in/" />
            </Helmet>

            <div id="page" className="site">
              <div className="unicamp-modern-slider-style-05 carousel__margin">
                <Carousel>
                  {homeBanners?.map((homebannerResult, index) => {
                    return (
                      <Carousel.Item key={index}>
                        <img
                          src={`${imagebaseurl}/${homebannerResult?.bannerImage}`}
                          style={{ width: "100%" }}
                          alt={bannerImageAltText[index]}
                          fetchpriority="high"
                          // onClick={() =>
                          //   handleShow(
                          //     `${imagebaseurl}/${homebannerResult?.bannerImage}`
                          //   )
                          // }
                          onClick={() => handleShowAdmissionEnquiryForm(index)}
                        />

                        <Carousel.Caption>
                          <div class="slide-content tm-modern-slider">
                            <div class="slide-layers">
                              <div class="slide-layer-wrap title-wrap">
                                <div class="slide-layer">
                                  {/* <h1 className="title">{homebannerResult?.bannerName}</h1> */}
                                </div>
                              </div>
                              <div class="slide-layer-wrap description-wrap">
                                <div class="slide-layer"></div>
                              </div>
                              <ul class="view_btns"></ul>
                            </div>
                          </div>
                        </Carousel.Caption>
                      </Carousel.Item>
                    );
                  })}
                </Carousel>
                {/* <Modal size='lg' className="d-none d-md-block d-lg-block" show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title> Admission Enquiry Form </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div class="bg-white">
                        <div class="modlaPopup">
                          
                          <div class="elementor-widget-container">
                            <div class="tm-modern-heading">
                           
                              <div class="heading-description-wrap">
                                <div class="heading-description">
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="elementor-widget-container">
                            <div class="unicamp-contact-form-7">
                              <div class="wpcf7">
                                <form action="#" method="post" class="wpcf7-form init">
                                  <div class="form-group">
                                    <lable>Your Name</lable>
                                    <input class="form-control" placeholder="Name"
                                      onChange={(e) => setName(e.target.value)}
                                      type="text" name="name" value={name}
                                    />
                                  </div>
                                  <div class="form-group">
                                    <lable>Your Email</lable>
                                    <input class="form-control" placeholder="Email ID"
                                      onChange={(e) => setEmail(e.target.value)}
                                      value={email} type="email" name="email" />
                                  </div>
                                  <div class="form-group">
                                    <label>Mobile Number</label>
                                    <input class="form-control" placeholder="Phone"
                                      onChange={(e) => setMobile(e.target.value)}
                                      value={mobile} type="number" name="mobile" />
                                  </div>
                                  <div class="form-group">
                                    <label>City</label>
                                    <input class="form-control" placeholder="City"
                                      onChange={(e) => setCity(e.target.value)}
                                      value={city} type="text" name="city" />
                                  </div>
                                  <div class="form-group">
                                    <label>Course</label>
                                    <select required="" size="1" name="course"
                                      onChange={(e) => setCourse(e.target.value)} class="form-control">
                                      <option value="">Please select Any Course
                                      </option>
                                      <option value="B.Tech. Courses[CS,IT,AI &amp; DS,CSIT]">Engineering Courses [CS,IT,AI &amp; DS,CSIT]
                                      </option>
                                      <option value="B.Tech. Course [EC]">Engineering Course [Electronics &amp; Comm. Engg.]
                                      </option>
                                      <option value="B.Tech. Course [ME]">Engineering Course [Mechnical Engineering]
                                      </option>
                                      <option value="B.Tech. Course [Civil Engg.]">Engineering Course [Civil Engineering]
                                      </option>
                                      <option value="Pharmacy Courses[B.Pharm, D.Pharm]">Pharmacy Courses [B.Pharm, D.Pharm]
                                      </option>
                                      <option value="Pharmacy Course[M.Pharm]">Pharmacy Course [M.Pharm]
                                      </option>
                                      <option value="Management Courses[MBA(FT,MM,FA)]">Management Courses[MBA(FT,MM,FA)]
                                      </option>
                                      <option value="Professional Course [BBA]">Professional Courses [BBA]
                                      </option>
                                      <option value="Professional Course[BCA]">Professional Courses [BCA]
                                      </option>
                                      <option value="Professional Course[B.Com]">Professional Courses [B.Com]
                                      </option>
                                      <option value="Law Courses(LLB Hons, BA LLB Hons, BBA LLB Hons)">Law Courses [LLB Hons, BA LLB Hons, BBA LLB Hons]
                                      </option>
                                      <option value="MCA Course">MCA Course
                                      </option>
                                    </select>
                                  </div>
                                  <div class="form-group">
                                    <label>What is nine plus five?</label>
                                    <input class="form-control" placeholder="Answer" value={mathAnswer}
                                      onChange={(e) => setMathAnswer(e.target.value)}
                                      type="text" name="mathAnswer" />
                                  </div>
                                  <div class="form-group">
                                    <div class="form-submit">
                                      <button type="button" onClick={HandleSubmit}>
                                        Submit
                                      </button>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div >
                      </div >
                    </Modal.Body >

                  </Modal > */}
                {/* <Modal size='lg' className="d-none d-md-block d-lg-block" show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title> Admission Enquiry Form </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-white">
            <div className="modlaPopup">
              <form className="wpcf7-form init">
                <div className="form-group">
                  <label>Your Name</label>
                  <input className="form-control" placeholder="Name" onChange={(e) => setName(e.target.value)} type="text" name="name" value={name} />
                </div>
                <div className="form-group">
                  <label>Your Email</label>
                  <input className="form-control" placeholder="Email ID" onChange={(e) => setEmail(e.target.value)} value={email} type="email" name="email" />
                </div>
                <div className="form-group">
                  <label>Mobile Number</label>
                  <input className="form-control" placeholder="Phone" onChange={(e) => setMobile(e.target.value)} value={mobile} type="number" name="mobile" />
                </div>
                <div className="form-group">
                  <label>City</label>
                  <input className="form-control" placeholder="City" onChange={(e) => setCity(e.target.value)} value={city} type="text" name="city" />
                </div>
                <div className="form-group">
                  <label>Course</label>
                  <select required size="1" name="course" onChange={(e) => setCourse(e.target.value)} className="form-control">
                    <option value="">Please select Any Course</option>
                    <option value="B.Tech. Courses[CS,IT,AI & DS,CSIT]">Engineering Courses [CS,IT,AI & DS,CSIT]</option>
                    <option value="B.Tech. Course [EC]">Engineering Course [Electronics & Comm. Engg.]</option>
                    <option value="B.Tech. Course [ME]">Engineering Course [Mechanical Engineering]</option>
                    <option value="B.Tech. Course [Civil Engg.]">Engineering Course [Civil Engineering]</option>
                    <option value="Pharmacy Courses[B.Pharm, D.Pharm]">Pharmacy Courses [B.Pharm, D.Pharm]</option>
                    <option value="Pharmacy Course[M.Pharm]">Pharmacy Course [M.Pharm]</option>
                    <option value="Management Courses[MBA(FT,MM,FA)]">Management Courses [MBA(FT,MM,FA)]</option>
                    <option value="Professional Course [BBA]">Professional Courses [BBA]</option>
                    <option value="Professional Course[BCA]">Professional Courses [BCA]</option>
                    <option value="Professional Course[B.Com]">Professional Courses [B.Com]</option>
                    <option value="Law Courses(LLB Hons, BA LLB Hons, BBA LLB Hons)">Law Courses [LLB Hons, BA LLB Hons, BBA LLB Hons]</option>
                    <option value="MCA Course">MCA Course</option>
                  </select>
                </div>
                <div className="form-group">   </Link>
                  <label>What is nine plus five?</label>
                  <input className="form-control" placeholder="Answer" value={mathAnswer} onChange={(e) => setMathAnswer(e.target.value)} type="text" name="mathAnswer" />
                </div>
                <div className="form-group">
                  <div className="form-submit">
                    <button type="button" onClick={HandleSubmit}>Submit</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
                {/* Web verion admission enquiry form */}
                {/* <Modal
  size="lg"
  className="custom-modal d-none d-md-block d-lg-block"
  show={show}
  onHide={closeModal}
>
  <Modal.Header closeButton style={{ backgroundColor: '#004080', color: '#fff' }}>
    <Modal.Title style={{textAlign:"center"}} className='text-center'>Admission Enquiry Form</Modal.Title>
  </Modal.Header>

  <Modal.Body style={{ backgroundColor: '#f8f9fa' }}>
    <div className="bg-white p-4 rounded shadow-sm">
      <div className="elementor-widget-container">
        <div className="unicamp-contact-form-7">
          <form action="#" method="post" className="wpcf7-form init">
            <div className="form-group mb-3">
              <label className="fw-bold">Your Name</label>
              <input
                className="form-control"
                placeholder="Name"
                onChange={(e) => setName(e.target.value)}
                type="text"
                name="name"
                value={name}
              />
            </div>

            <div className="form-group mb-3">
              <label className="fw-bold">Your Email</label>
              <input
                className="form-control"
                placeholder="Email ID"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                type="email"
                name="email"
              />
            </div>

            <div className="form-group mb-3">
              <label className="fw-bold">Mobile Number</label>
              <input
                className="form-control"
                placeholder="Phone"
                onChange={(e) => setMobile(e.target.value)}
                value={mobile}
                type="number"
                name="mobile"
              />
            </div>

            <div className="form-group mb-3">
              <label className="fw-bold">City</label>
              <input
                className="form-control"
                placeholder="City"
                onChange={(e) => setCity(e.target.value)}
                value={city}
                type="text"
                name="city"
              />
            </div>

            <div className="form-group mb-3">
              <label className="fw-bold">Course</label>
              <select
                required
                name="course"
                onChange={(e) => setCourse(e.target.value)}
                className="form-control"
              >
                <option value="">Please select Any Course</option>
                <option value="B.Tech. Courses[CS,IT,AI & DS,CSIT]">Engineering Courses [CS, IT, AI & DS, CSIT]</option>
                <option value="B.Tech. Course [EC]">Engineering Course [Electronics & Comm. Engg.]</option>
                <option value="B.Tech. Course [ME]">Engineering Course [Mechanical Engineering]</option>
                <option value="B.Tech. Course [Civil Engg.]">Engineering Course [Civil Engineering]</option>
                <option value="Pharmacy Courses[B.Pharm, D.Pharm]">Pharmacy Courses [B.Pharm, D.Pharm]</option>
                <option value="Pharmacy Course[M.Pharm]">Pharmacy Course [M.Pharm]</option>
                <option value="Management Courses[MBA(FT,MM,FA)]">Management Courses [MBA(FT, MM, FA)]</option>
                <option value="Professional Course [BBA]">Professional Courses [BBA]</option>
                <option value="Professional Course[BCA]">Professional Courses [BCA]</option>
                <option value="Professional Course[B.Com]">Professional Courses [B.Com]</option>
                <option value="Law Courses(LLB Hons, BA LLB Hons, BBA LLB Hons)">
                  Law Courses [LLB Hons, BA LLB Hons, BBA LLB Hons]
                </option>
                <option value="MCA Course">MCA Course</option>
              </select>
            </div>

            <div className="form-group mb-4">
              <label className="fw-bold">What is nine plus five?</label>
              <input
                className="form-control"
                placeholder="Answer"
                value={mathAnswer}
                onChange={(e) => setMathAnswer(e.target.value)}
                type="text"
                name="mathAnswer"
              />
            </div>

            <div className="form-group text-center">
              <button type="button" onClick={HandleSubmit} className="btn btn-primary px-5">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Modal.Body>
</Modal> */}
              </div>
              <div className="content-wrapper">
                <div id="page-content" className="page-content m-0 p74s24d">
                  <div id="page-main-content" className="page-main-content">
                    <article
                      id="post-2585"
                      className="post-2585 page type-page status-publish hentry post-no-thumbnail"
                    >
                      <div className="elementor elementor-2585">
                        <div className="elementor-inner">
                          <div className="elementor-section-wrap">
                            <Banners />
                            <div className="overview-area aboutus-vi">
                              <div className="container">
                                {image?.length > 0 ? (
                                  image?.map((about, index) => (
                                    <div className="row" key={index}>
                                      {index % 2 === 1 ? (
                                        <>
                                          <div className="col-lg-6">
                                            <div className="overview-content"></div>
                                          </div>
                                          <div className="col-lg-6">
                                            <div className="overview-image m-0"></div>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className="col-lg-6">
                                            <div className="overview-content">
                                              <img
                                                src={`${imagebaseurl}/${about?.images}`}
                                                alt="best colleges in indore"
                                              />
                                            </div>
                                            <div className="title d-flex align-items-center">
                                              <h2 className="d-flex align-items-center">
                                                <img
                                                  src={bookicon}
                                                  alt="title-shape"
                                                />
                                                <span
                                                  akhi="20"
                                                  className="counter value"
                                                >
                                                  20
                                                </span>
                                                +
                                                <Link
                                                  className="text-decoration-none arrow-btn"
                                                  to="/#"
                                                >
                                                  More Graduates Programs
                                                  {/* <i><FaArrowRight /></i> */}
                                                </Link>
                                              </h2>
                                            </div>
                                          </div>
                                          <div className="col-lg-6">
                                            <div className="overview-content">
                                              <div className="title">
                                                <h2 className="d-flex align-items-center">
                                                  <img
                                                    src={penicon}
                                                    alt="title-shape"
                                                  />
                                                  {ReactHtmlParser(about.title)}
                                                </h2>
                                                <div>
                                                  {" "}
                                                  {ReactHtmlParser(
                                                    about?.content
                                                  )}
                                                </div>
                                              </div>
                                              <Link
                                                className="text-decoration-none arrow-btn mt-4"
                                                to="/About_Institutions"
                                              >
                                                View More
                                                <i>
                                                  <FaArrowRight />
                                                </i>
                                              </Link>
                                            </div>
                                            <div className="casual-image greddd">
                                              <img
                                                src={about1}
                                                alt="best colleges in madhya pradesh"
                                              />
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  ))
                                ) : (
                                  <Bars
                                    height="80"
                                    width="80"
                                    color="#4fa94d"
                                    ariaLabel="bars-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                    visible={true}
                                  />
                                  // <p>Loading data.......</p>
                                )}
                              </div>
                            </div>
                            {exploreBanners?.slice().reverse()[0] && (
                              <section
                                className="elementor-section programs101 elementor-top-section elementor-element elementor-element-063448a elementor-section-content-middle
                                    elementor-section-boxed elementor-section-gap-beside-yes elementor-section-height-default elementor-section-height-default
                                    elementor-section-column-vertical-align-stretch"
                                style={{
                                  backgroundImage: `url(${imagebaseurl}/${
                                    exploreBanners.slice().reverse()[0].image
                                  })`,
                                }}
                              >
                                <div className="elementor-container elementor-column-gap-extended">
                                  <div className="elementor-row">
                                    <div
                                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-69ad18c"
                                      data-id="69ad18c"
                                      data-element_type="column"
                                    >
                                      <div className="elementor-column-wrap elementor-element-populated">
                                        <div className="elementor-widget-wrap">
                                          <div
                                            className="elementor-element elementor-element-977e01f unicamp-modern-heading-style-04 elementor-invisible 
                                          elementor-widget elementor-widget-tm-heading"
                                            data-id="977e01f"
                                            data-element_type="widget"
                                            data-settings='{"_animation":"unicampFadeInUp"}'
                                            data-widget_type="tm-heading.default"
                                          >
                                            <div className="elementor-widget-container">
                                              <div className="tm-modern-heading" style={{width: "100%"}}>
                                                <div className="heading-primary-wrap">
                                                  <h2 className="heading-primary elementor-heading-title">
                                                    <mark className="header-title">
                                                      {" "}
                                                      
                                                      Apply @ CDGI 
                                                    </mark>
                                                    {/* <mark>  Explore <span style={{color:'#004b9c'}}>CDGI</span>  <br/>
                                                    </mark> */}
                                                  </h2>
                                                </div>

                                                <div className="heading-description-wrap">
                                                  <div className="heading-description">
                                                    {
                                                      exploreBanners
                                                        ?.slice()
                                                        .reverse()[0].subHeading
                                                    }
                                                    {/* Choose from 20+ Undergraduate and Postgraduate Programs */}
                                          
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="elementor-element elementor-element-e60b0c2 elementor-mobile-align-center elementor-invisible elementor-widget elementor-widget-tm-button"
                                            data-id="e60b0c2"
                                            data-element_type="widget"
                                            data-settings='{"_animation":"unicampFadeInUp"}'
                                            data-widget_type="tm-button.default"
                                          >
                                                 <button    onClick={openModal}>Apply Now</button>
                                            <div className="elementor-widget-container">
                                              <div className="tm-button-wrapper"></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-a4ccc2b"
                                      data-id="a4ccc2b"
                                      data-element_type="column"
                                    >
                                      <div className="elementor-column-wrap">
                                        <div className="elementor-widget-wrap"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </section>
                            )}
                            <Campus />
                            <div className="funfact-area pb-75">
                              <div className="container">
                                <div className="row g-0 justify-content-center">
                                  {data?.length > 0 ? (
                                    data?.slice(0, 4)?.map((dates, index) => (
                                      <div
                                        key={index}
                                        className="col-lg-3 col-sm-6 col-xs-6 col-md-6"
                                      >
                                        <div className="single-funfact-info text-center">
                                          <h2 className="d-flex align-items-center justify-content-center">
                                            <span
                                              akhi="10000"
                                              className="counter value"
                                            >
                                              {dates?.factNumber}
                                            </span>
                                          </h2>
                                          <p>{dates?.factName}</p>
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    <p>No images available</p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <section className="contact_sec">
                              <div className="container">
                                <div className="contact_topdd">
                                  <div className="row">
                                    <div className="col-md-6 col-lg-4">
                                      <div className="elementor-widget-wrap">
                                        <div className="unicamp-contact-box-style-01  animated unicampFadeInUp">
                                          <div className="unicamp-box unicamp-contact-box">
                                            <div className="calendericons">
                                              <i>
                                                <FaRegCalendarAlt />
                                              </i>
                                            </div>
                                            <h4 className="contact-box-title">
                                              Placement Activity
                                            </h4>
                                            <div className="contact-box-info">
                                              <div className="contact-box-info-item address">
                                                <span className="meta-label">
                                                  More than 300+ for the AY:2022
                                                  and More than 200+ students
                                                  offered from various reputed
                                                  companies for the AY:2023 till
                                                  now
                                                </span>
                                                <Link
                                                  to="/Placement"
                                                  className="mt-5 tm-button-link tm-button style-flat tm-button-nm icon-right"
                                                >
                                                  <div className="button-content-wrapper">
                                                    <span className="button-text">
                                                      Read More
                                                    </span>
                                                    <span className="button-icon">
                                                      <FaArrowRight />
                                                    </span>
                                                  </div>
                                                </Link>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6 col-lg-4">
                                      <div className="elementor-widget-wrap">
                                        <div className="unicamp-contact-box-style-01  animated unicampFadeInUp">
                                          <div className="unicamp-box unicamp-contact-box">
                                            <div className="calendericons">
                                              <i>
                                                <FaNewspaper />
                                              </i>
                                            </div>
                                            <h4 className="contact-box-title">
                                              News and Events
                                            </h4>
                                            <div className="contact-box-info">
                                              <div className="contact-box-info-item address">
                                                <span className="meta-label">
                                                  First International conference
                                                  on Energy Conservation and
                                                  Sustainable Development using
                                                  AI
                                                </span>
                                                <Link
                                                  to="/News_And_Events"
                                                  className="mt-5 tm-button-link tm-button style-flat tm-button-nm icon-right"
                                                >
                                                  <div className="button-content-wrapper">
                                                    <span className="button-text">
                                                      Read More
                                                    </span>
                                                    <span className="button-icon">
                                                      <FaArrowRight />
                                                    </span>
                                                  </div>
                                                </Link>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6 col-lg-4">
                                      <div className="elementor-widget-wrap">
                                        <div className="unicamp-contact-box-style-01  animated unicampFadeInUp">
                                          <div className="unicamp-box unicamp-contact-box">
                                            <div className="calendericons">
                                              <i>
                                                <FaLayerGroup />
                                              </i>
                                            </div>
                                            <h4 className="contact-box-title">
                                              Tie-ups,MoUs & Associations
                                            </h4>
                                            <div className="contact-box-info">
                                              <div className="contact-box-info-item address">
                                                <span className="meta-label">
                                                  The institute has life time
                                                  memberships, corporate tie ups
                                                  and MoUs with high profile,
                                                  renowned organizations.
                                                </span>
                                                <Link
                                                  to="/Mous_Tie"
                                                  className="mt-5 tm-button-link tm-button style-flat tm-button-nm icon-right"
                                                >
                                                  <div className="button-content-wrapper">
                                                    <span className="button-text">
                                                      Read More
                                                    </span>
                                                    <span className="button-icon">
                                                      <FaArrowRight />
                                                    </span>
                                                  </div>
                                                </Link>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <Gallery />
                            <section
                              className="bg-light py-5 elementor-section-column-vertical-align-stretch"
                              data-id="161aa64"
                              data-element_type="section"
                              data-settings='{"background_background":"classNameic"}'
                            >
                              <div className="container">
                                <div className="row">
                                  <div className="col-md-7 col-lg-8 col-sm-12">
                                    <div className="elementor-widget-wrap">
                                      <div
                                        className="elementor-element elementor-element-508ee1e elementor-widget__width-auto elementor-invisible elementor-widget elementor-widget-tm-heading"
                                        data-id="508ee1e"
                                        data-element_type="widget"
                                        data-settings='{"_animation":"unicampFadeInUp"}'
                                        data-widget_type="tm-heading.default"
                                      >
                                        <div className="elementor-widget-container">
                                          <div className="tm-modern-heading">
                                            <div className="heading-primary-wrap d-flex align-items-center justify-content-between">
                                              <h4 className="heading-primary elementor-heading-title">
                                                Placement Activity
                                              </h4>

                                              <Link to="/placement">
                                                <button className="button-content-wrapper">
                                                  <span className="button-text">
                                                    View all
                                                  </span>
                                                  <span className="button-icon">
                                                    <FaArrowRight />
                                                  </span>
                                                </button>
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="elementor-element elementor-element-7b2dee9 elementor-widget__width-auto elementor-invisible elementor-widget elementor-widget-tm-button"
                                          data-id="7b2dee9"
                                          data-element_type="widget"
                                          data-settings='{"_animation":"unicampFadeInUp"}'
                                          data-widget_type="tm-button.default"
                                        >
                                          <div className="elementor-widget-container">
                                            <div className="tm-button-wrapper">
                                              <Link
                                                to="#"
                                                className="tm-button-link tm-button style-text tm-button-nm icon-right"
                                                role="button"
                                              ></Link>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="elementor-element elementor-element-dcdf23e elementor-widget elementor-widget-spacer"
                                          data-id="dcdf23e"
                                          data-element_type="widget"
                                          data-widget_type="spacer.default"
                                        >
                                          <div className="elementor-widget-container">
                                            <div className="elementor-spacer">
                                              <div className="elementor-spacer-inner"></div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="elementor-element elementor-element-7e3199b unicamp-animation-zoom-in unicamp-blog-caption-style-01 bullets-v-align-below elementor-invisible elementor-widget elementor-widget-tm-post-carousel"
                                          data-id="7e3199b"
                                          data-element_type="widget"
                                          data-settings='{"swiper_items":"3","swiper_items_mobile":"auto-fixed","_animation":"unicampFadeInUp","swiper_items_tablet":"2"}'
                                          data-widget_type="tm-post-carousel.default"
                                        >
                                          <div className="elementor-widget-container">
                                            <div className="tm-swiper tm-slider-widget pagination-style-01 bullets-horizontal bullets-h-align-center bullets-v-align-below unicamp-blog">
                                              <Slider
                                                {...settings}
                                                style={{ gap: "20px" }}
                                              >
                                                {slides?.map((slid, index) => (
                                                  <div
                                                    key={index}
                                                    className="swiper-inner ks45785d"
                                                  >
                                                    <div className="post-wrapper unicamp-box">
                                                      <div className="post-feature post-thumbnail unicamp-image">
                                                        <Link to="#">
                                                          <img
                                                            src={`${imagebaseurl}/${slid?.images}`}
                                                            alt={slid?.title}
                                                            style={{
                                                              width: "380px",
                                                              height: "300px",
                                                            }}
                                                          />
                                                        </Link>
                                                      </div>
                                                      <div className="post-caption">
                                                        <div className="post-categories">
                                                          <Link to="#">
                                                            <span
                                                              className="cat-shape"
                                                              style={{
                                                                background:
                                                                  "#a371ff",
                                                              }}
                                                            ></span>
                                                            <span className="cat-name">
                                                              Student
                                                            </span>
                                                          </Link>
                                                        </div>
                                                        <h3 className="post-title post-title-2-rows">
                                                          <Link to="#">
                                                            {slid?.title}
                                                          </Link>
                                                        </h3>
                                                        <div className="post-meta">
                                                          <div className="inner">
                                                            <div className="post-meta-author">
                                                              <Link to="#author/thememove/">
                                                                <span className="meta-value">
                                                                  Chameli Devi
                                                                </span>
                                                              </Link>
                                                            </div>
                                                            <div className="post-date">
                                                              <span className="meta-value">
                                                                July 29, 2024
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ))}
                                              </Slider>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="col-md-5 col-lg-4 col-sm-12"
                                    data-id="3e786b3"
                                    data-element_type="column"
                                  >
                                    <div className="elementor-column-wrap elementor-element-populated">
                                      <div className="elementor-widget-wrap">
                                        <div
                                          className="elementor-element elementor-element-181eb0b elementor-invisible elementor-widget elementor-widget-tm-event-box"
                                          data-id="181eb0b"
                                          data-element_type="widget"
                                          data-settings='{"_animation":"unicampFadeInUp"}'
                                          data-widget_type="tm-event-box.default"
                                        >
                                          <div className="elementor-widget-container">
                                            <div className="unicamp-event-box unicamp-box">
                                              <div className="box-header">
                                                <h4 className="box-title">
                                                  News and Events
                                                </h4>

                                                <Link to="/News_And_Events">
                                                  <button className="button-content-wrapper px-2">
                                                    <span className="button-text">
                                                      View all
                                                    </span>
                                                    <span className="button-icon">
                                                      <FaArrowRight />
                                                    </span>
                                                  </button>
                                                </Link>

                                                <div className="tm-button-wrapper">
                                                  <Link
                                                    className="tm-button style-text tm-button-nm icon-right"
                                                    to="#"
                                                  >
                                                    <div className="button-content-wrapper"></div>
                                                  </Link>
                                                </div>
                                              </div>
                                              <Link to="/News_And_Events">
                                                <div className="box-body">
                                                  {placementList
                                                    ?.slice(0, 3)
                                                    ?.map(
                                                      (
                                                        News_And_Events_Result
                                                      ) => {
                                                        return (
                                                          <>
                                                            <div className="post-item">
                                                              <div className="event-caption">
                                                                <div className="left-box">
                                                                  <div className="event-date">
                                                                    <div className="event-date--day">
                                                                      {new Date(
                                                                        News_And_Events_Result.date
                                                                      ).toLocaleDateString(
                                                                        "en-US",
                                                                        {
                                                                          day: "numeric",
                                                                        }
                                                                      )}
                                                                    </div>
                                                                    <div className="event-date--month">
                                                                      {new Date(
                                                                        News_And_Events_Result.date
                                                                      ).toLocaleDateString(
                                                                        "en-US",
                                                                        {
                                                                          month:
                                                                            "short",
                                                                        }
                                                                      )}
                                                                    </div>
                                                                  </div>
                                                                </div>

                                                                <div className="right-box">
                                                                  <p className="post-title post-title-2-rows title-has-link">
                                                                    <a
                                                                      href="#"
                                                                      className="event-meta"
                                                                    >
                                                                      {ReactHtmlParser(
                                                                        News_And_Events_Result?.title
                                                                      )}
                                                                    </a>
                                                                  </p>
                                                                  <div className="event-meta">
                                                                    <div className="event-time">
                                                                      {
                                                                        News_And_Events_Result?.time
                                                                      }
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </>
                                                        );
                                                      }
                                                    )}
                                                </div>
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                </div>
              </div>
              {/* <Trained /> */}
            </div>

            {/*  
            {showTopIcon ? (
              <Link
                id="scrollUp"
                to="#"
                onClick={scrollToTop}
                style={{
                  position: "fixed",
                  bottom: "20px",
                  right: "0px",
                  zIndex: "2147483647",
                  backgroundColor: "red",
                  color: "#fff",
                  padding: "10px",
                  borderRadius: "55%",
                  zIndex: " 111",
                  textAlign: "center",
                  boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.3)",
                }}
              >
                <TiArrowUp style={{ fontSize: "24px" }} />
              </Link>
            ) : (
              <Link
                id="scrollBottom"
                to="#"
                onClick={scrollToBottom}
                style={{
                  position: "fixed",
                  bottom: "20px",
                  right: "0px",
                  zIndex: "2147483647",
                  backgroundColor: "red",
                  color: "#fff",
                  padding: "10px",
                  borderRadius: "50%",
                  zIndex: " 111",
                  textAlign: "center",
                  boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.3)",
                }}
              >
                <TiArrowDown style={{ fontSize: "24px" }} />
              </Link>
            )}

            */}
            {/* <button
              onClick={handleWhatsAppClick}
              style={{
                position: "fixed",
                bottom: "20px",
                right: "80px",
                zIndex: "9999",
                backgroundColor: "#25D366",
                color: "white",
                border: "none",
                outline: "none",
                padding: "10px 15px",
                borderRadius: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "11px",
                fontWeight: "500",
                cursor: "pointer",
                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.3)",
              }}
            >
              <FaWhatsapp size={40} />
              Chat for Admission Enquiry
            </button> */}

            <style>{`
.asmission_enquiry {
z-index:333333;
}
        .vertical-buttons {
          position: fixed;
          top: 50%;
          right: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          z-index: 1000;
        }

        .vertical-btn {
          writing-mode: vertical-rl;
          transform: rotate(180deg);
          background-color: #e60000;
          color: white;
          border: none;
          padding: 12px 8px;
          margin: 5px 0;
          cursor: pointer;
          font-weight: bold;
          border-radius: 50px ;
          font-size: 16px;
          width: 50px;
          text-align: center;
          line-height: 50px;
          transition: background-color 0.3s ease, transform 0.3s ease;
        }

        .vertical-btn:hover {
          background-color: #cc0000;
          transform: rotate(180deg) scale(1.05);
        }

        @media (max-width: 768px) {
          .vertical-buttons {
            top: 45%;
          }
         .vertical-btn {
    padding: 8px 4px;
    font-size: 12px;
    width: 40px;
    align-items: center;
    justify-content: center;
    display: flex;
}
        }

        @media (max-width: 480px) {
          .vertical-btn {
    padding: 8px 4px;
    font-size: 12px;
    width: 40px;
    align-items: center;
    justify-content: center;
    display: flex;
}
        }
      `}</style>

            {/* Vertical Button */}
            <div className="vertical-buttons d-lg-none">
              <button
                className="vertical-btn "
                style={{ height: "180px" }}
                onClick={openModal}
              >
                Admissions Enquiry
              </button>
            </div>

            {/* Modal Code */}
            <Modal
              size="lg"
              className="asmission_enquiry"
              show={showModal}
              onHide={closeModal}
            >
              <Modal.Header closeButton>
                <Modal.Title
                  className="text-center"
                  style={{
                    textAlign: "center",
                    width: "100%",
                    color: "#007bff",
                  }}
                >
                  Admissions Enquiry Form
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="bg-white p-2 p-lg-5">
                  <div className="modlaPopup">
                    <div className="elementor-widget-container">
                      <form className="wpcf7-form">
                        <div className="form-group mb-3">
                          <label>Your Name</label>
                          <input
                            className="form-control"
                            placeholder="Name"
                            onChange={(e) => setName(e.target.value)}
                            type="text"
                            name="name"
                            value={name}
                          />
                          {nameError && (
                            <p className="text-danger">{nameError}</p>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>Your Email</label>
                          <input
                            className="form-control"
                            placeholder="Email ID"
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            name="email"
                            value={email}
                          />
                          {emailError && (
                            <p className="text-danger">{emailError}</p>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>Mobile Number</label>
                          <input
                            className="form-control"
                            placeholder="Phone"
                            onChange={(e) => setMobile(e.target.value)}
                            type="number"
                            name="mobile"
                            value={mobile}
                          />
                          {mobileError && (
                            <p className="text-danger">{mobileError}</p>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>City</label>
                          <input
                            className="form-control"
                            placeholder="City"
                            onChange={(e) => setCity(e.target.value)}
                            type="text"
                            name="city"
                            value={city}
                          />
                          {cityError && (
                            <p className="text-danger">{cityError}</p>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>Course</label>
                          <select
                            className="form-control"
                            required
                            name="course"
                            value={course}
                            onChange={(e) => setCourse(e.target.value)}
                          >
                            <option value="">Please select Any Course</option>
                            <option value="B.Tech. Courses[CS,IT,AI & DS,CSIT]">
                              Engineering Courses [CS, IT, AI & DS, CSIT]
                            </option>
                            <option value="B.Tech. Course [EC]">
                              Engineering Course [Electronics & Comm. Engg.]
                            </option>
                            <option value="B.Tech. Course [ME]">
                              Engineering Course [Mechanical Engineering]
                            </option>
                            <option value="B.Tech. Course [Civil Engg.]">
                              Engineering Course [Civil Engineering]
                            </option>
                            <option value="Pharmacy Courses[B.Pharm, D.Pharm]">
                              Pharmacy Courses [B.Pharm, D.Pharm]
                            </option>
                            <option value="Pharmacy Course[M.Pharm]">
                              Pharmacy Course [M.Pharm]
                            </option>
                            <option value="Management Courses[MBA(FT,MM,FA)]">
                              Management Courses [MBA(FT,MM,FA)]
                            </option>
                            <option value="Professional Course [BBA]">
                              Professional Courses [BBA]
                            </option>
                            <option value="Professional Course[BCA]">
                              Professional Courses [BCA]
                            </option>
                            <option value="Professional Course[B.Com]">
                              Professional Courses [B.Com]
                            </option>
                            <option value="Law Courses(LLB Hons, BA LLB Hons, BBA LLB Hons)">
                              Law Courses [LLB Hons, BA LLB Hons, BBA LLB Hons]
                            </option>
                            <option value="MCA Course">MCA Course</option>
                          </select>
                          {courseError && (
                            <p className="text-danger">{courseError}</p>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>What is nine plus five?</label>
                          <input
                            className="form-control"
                            placeholder="Answer"
                            onChange={(e) => setMathAnswer(e.target.value)}
                            type="text"
                            name="mathAnswer"
                            value={mathAnswer}
                          />
                          {sumAnswerError && (
                            <p className="text-danger">{sumAnswerError}</p>
                          )}
                        </div>
                        {/* 
                  <div className="form-group">
                    <div className="form-submit">
                      <button  type="button" onClick={HandleSubmit} className="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </div> */}

                        <div className="form-group mb-3 text-center">
                          <button
                            className="btn btn-primary w-100"
                            type="submit"
                            onClick={HandleSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            <InstitutionHighlights />
            <Footer />
          </div>
        </>
      )}
    </div>
  );
};

export default Home;
